import { IEquipment } from '../../../equipment.types.ts'
import Card from '../../../../../shared/Card'
import EquipmentStatus from '../EquipmentStatus'
import GoToLink from '@/assets/icons/goToLink.svg?react'
import equipmentUtils from '@/pages/Equipment/equipment.utils.ts'
import { CSSProperties } from 'react'

interface IProps {
  equipment: IEquipment
  onClick?: () => void
  active?: boolean
  minified?: boolean
}

const ShortEquipmentCard = (props: IProps) => {
  if (!props.equipment) return null

  let style: CSSProperties = {}
  if (props.active) {
    style.borderColor = 'var(--border-color)'
  }
  if (props.minified) {
    style.paddingTop = '8px'
  }

  return (
    <Card active={props.active} onClick={props.onClick} style={style}>
      <div className="flex-lines gap8">
        {props.minified !== true && (
          <div className="flex-space-between">
            <EquipmentStatus equipment={props.equipment} />
            <GoToLink style={{ color: 'var(--text-description)' }} />
          </div>
        )}
        {props.equipment.location && (
          <div className="flex-lines">
            <div className="inline-flex-gap gap12 center">
              {Boolean(props.minified) && (
                <div
                  style={{
                    height: '8px',
                    width: '8px',
                    borderRadius: '50%',
                    backgroundColor: equipmentUtils.getStatusFlagColor(props.equipment.statusFlag),
                    flexShrink: 0,
                  }}
                />
              )}
              <p className="text-nm" style={{ color: '#000' }}>
                {equipmentUtils.getEquipmentAddress(props.equipment.location)}
              </p>
            </div>

            {props.minified !== true && (
              <p className="text-caption text-description">{props.equipment.location.locationDescription}</p>
            )}
          </div>
        )}
      </div>
    </Card>
  )
}

export default ShortEquipmentCard
